import { render, staticRenderFns } from "./MapCollection.vue?vue&type=template&id=46723590&scoped=true&"
import script from "./MapCollection.vue?vue&type=script&lang=js&"
export * from "./MapCollection.vue?vue&type=script&lang=js&"
import style0 from "./MapCollection.vue?vue&type=style&index=0&id=46723590&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46723590",
  null
  
)

export default component.exports